import React, { useContext, useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { AiOutlineArrowLeft } from "react-icons/ai";

// Layout & Components
import MALayout from "../../../Components/M&ALayout";
import Table from "../../../Components/MostActiveAcquirers/TableComponent";
import FilterTag from "../../../Components/Tag";
import MonthPickerComponent from "../../../Utils/MonthPickerComponent";

// Contexts
import { PeFilterContext } from "../../../Contexts/PeFilterContext";
import { UserContext } from "../../../Contexts/UserContext";

// Config & Constants
import Constants from "../../../Constants";
import { routeNames } from "../../../routeSegments";
import MostActiveAcquirerDownloader from "../../../Components/shared/MostActiveAcquirerDownloader";
import { FaFilter } from "react-icons/fa";
import line from "../../../images/line.png";
import MostActiveAcquirersRefineSearch from "../../../Components/RefineSearch/MostActiveAcquirersRefineSearch";
import Sidebar from "../../../Components/RefineSearchComponent";

function MostActiveAcquirer({ active }) {
  const {search, pathname} = useLocation()
  const [previousPath, setPreviousPath] = useState("")

  const {
    showMonthPicker,
    isMobile,
    setOpen,
    open,
    setIsMobile,
    monthPickerValue,
    setMonthPickerValue,
  } = useContext(PeFilterContext);

  const { isTrialExport, isStudent } = useContext(UserContext);

  // Mobile responsive setup
  useEffect(() => {
    if (window.innerWidth < 800) {
      // setOpen(true);
      setIsMobile(true);
    }
  }, [setOpen, setIsMobile]);

  useEffect(() => {
    if (!search) {
      console.log("⚠️ No search params found — skipping");
      return;
    }

    const params = new URLSearchParams(search);
    const fromDate = params.get("fromDate");
    const toDate = params.get("toDate");
    const previousPath = params.get("prePath");

    if (!fromDate || !toDate) {
      console.log("⚠️ Missing fromDate or toDate — no month range set");
      return;
    }
    
    try {
      setPreviousPath(previousPath);
      setMonthPickerValue([fromDate, toDate]);
      console.log("setting month", [fromDate, toDate], monthPickerValue)
    } catch (err) {
      console.error("❌ Error updating month picker:", err);
    }
    
  }, []);


  return (
    <MALayout menu="ma">
      <div className="flex flex-col min-h-screen h-screen">
        <div className="flex flex-1 min-h-0 overflow-hidden">
          <main className="flex flex-1 min-w-0 border-t border-gray-200 mt-[4.25rem] md:mt-[3rem]">
            <section className="flex flex-col flex-1 min-w-0 bg-[#EDEDED] lg:order-last h-full">
              {/* Back Button */}
              <div className="flex mt-2 mx-4">
                <NavLink to={previousPath.includes("companies") ? routeNames.MA_company : routeNames.MA_acquirers}>
                  <button className="flex items-center px-2 h-[24px] text-[14px] text-white bg-[#BC8B20] rounded-[5px] leading-[17px]">
                    <AiOutlineArrowLeft className="mr-2" />
                    <span className="whitespace-nowrap">Back</span>
                  </button>
                </NavLink>
              </div>

              {/* Filter tags (Mobile) */}
              {isMobile && <FilterTag />}

              {/* Header Section */}
              <div className="flex items-center justify-between mx-4 mt-4 bg-white rounded-t-md">
                <div className="w-full pr-4 md:pr-[0.7rem] lg:pr-4">
                  <div className="flex flex-row justify-between bg-white rounded-[6px] rounded-b-none">
                    {!isMobile && (
                      <div className="mt-1">
                        <FilterTag />
                      </div>
                    )}

                    <div
                      className={`items-center justify-between px-2 py-2 space-x-4 ${
                        showMonthPicker !== 0 ? "md:flex" : "flex"
                      }`}
                    >
                      <label className="text-[#666666]">
                        <div className={showMonthPicker !== 0 ? "" : "flex"}>
                          <MonthPickerComponent />
                        </div>
                      </label>

                      <button
                        className="cursor-pointer lg:ml-7 ml-4 mt-2"
                        onClick={() => setOpen(!open)}
                        aria-label="filter-button"
                      >
                        <FaFilter color="#bc8b20" size={21} />
                      </button>
                      <a>
                        <img
                          className="h-[24px] max-w-[2px] mt-1 "
                          src={line}
                        />
                      </a>

                      {/* Export Button */}
                      <div
                        className={`space-x-3 ${
                          showMonthPicker !== 0 ? "hidden md:flex" : "flex"
                        }`}
                      >
                        {isTrialExport !== "false" && isStudent !== "true" && (
                          <MostActiveAcquirerDownloader
                            menuItems={[
                              {
                                key: 'profile_only',
                                label: "Profile only",
                                fileName: "Most-Active-Acquirers",
                              },
                              {
                                key: 'profile_with_inv',
                                label: "Profile with acquisitions",
                                fileName: "Most-Active-Acquirers",
                              },
                              {
                                key: 'table_only',
                                label: 'Table only',
                                fileName: "Most-Active-Acquirers",
                              },
                            ]}
                          />
                            )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Table Section */}
              <div className="overflow-y-auto">
                <Table
                  menu="ma"
                  sub_type_master_id={Constants.subCategoryIds.ma_acquirer_id}
                />
              </div>
            </section>

              <aside className="hidden lg:order-first lg:block lg:flex-shrink-0">
                <div className="relative flex h-full  flex-col border-r border-gray-200 bg-[#FAF5EA]">
                  {/* Your content */}
                  <Sidebar>
                    <MostActiveAcquirersRefineSearch customPathname={pathname} />
                  </Sidebar>
                </div>
              </aside>

          </main>
        </div>
      </div>
    </MALayout>
  );
}

export default MostActiveAcquirer;
